module.exports = __webpack_public_path__ + "img/03@2x.7249f520.png";